import React from 'react'
import PropTypes from 'prop-types'
import Link from 'next/link'
import clsx from 'clsx'
import ResponsiveImage from 'components/images/responsive-image'
import ScrollLoader from 'components/shared/scroll-loader'
import { BUTTON_TYPES } from 'constants/button'
import Button from 'components/common/button'
import {
  PURPOSE_HERO_AND_DESC as CONST,
  PURPOSE_SHARED,
} from 'pages/purpose/const'
import { hasLocizeTranslation } from 'lib/utils/locize'
import VideoTeaser from 'components/purpose/video-teaser'
import { SEGMENT_STORAGE_KEY_CATEGORY } from 'lib/segment/const'
import Typo from 'constants/typography'
import styles from './styles.scss'
import PURPOSE_TOP_VID from './const'

function onLinkClicked() {
  sessionStorage.setItem(SEGMENT_STORAGE_KEY_CATEGORY.id, 'purpose_2019')
  sessionStorage.setItem(SEGMENT_STORAGE_KEY_CATEGORY.position, '')
  sessionStorage.setItem(SEGMENT_STORAGE_KEY_CATEGORY.type, 'landing_page')
  sessionStorage.setItem(SEGMENT_STORAGE_KEY_CATEGORY.subPos, '')
}

const PurposeHeroAndDesc = ({ isPhone, onClick, t }) => {
  const titleImg = CONST.titleImg[isPhone ? 0 : 1]
  const ourStoryImg = CONST.ourStoryImg[isPhone ? 0 : 1]

  return (
    <React.Fragment>
      <style jsx>{styles}</style>
      <VideoTeaser
        t={t}
        teaser={isPhone ? PURPOSE_TOP_VID.teaserMobile : PURPOSE_TOP_VID.teaser}
        isPhone={isPhone}
        titleImg={titleImg}
        onClick={onClick}
      />
      <section className="purpose-had__wrapper">
        <ScrollLoader id="purpose_after_hero">
          {isPhone && (
            <ResponsiveImage
              className="purpose-had__title"
              imgRatio={titleImg.ratio}
              src={titleImg.src}
            />
          )}
          <ResponsiveImage
            className={clsx(
              isPhone ? Typo.h6 : Typo.h4,
              'purpose-had__our-story',
            )}
            imgRatio={ourStoryImg.ratio}
            src={ourStoryImg.src}
          >
            <div className="overlay">
              {hasLocizeTranslation(t, CONST.ourStoryKey, CONST.ourStory)}
            </div>
          </ResponsiveImage>
        </ScrollLoader>
        <ScrollLoader>
          <div className="purpose-had__desc-wrapper">
            <span className={Typo.body2}>
              {hasLocizeTranslation(t, CONST.descKey, CONST.desc)}
            </span>
          </div>
          <Link
            href={PURPOSE_SHARED.shopCollectionHref}
            as={PURPOSE_SHARED.shopCollectionAs}
          >
            <a onClickCapture={onLinkClicked}>
              <Button
                type={BUTTON_TYPES.primary}
                className="purpose-had__shop-collection"
              >
                {hasLocizeTranslation(
                  t,
                  CONST.shopCollectionKey,
                  CONST.shopCollection,
                )}
              </Button>
            </a>
          </Link>
        </ScrollLoader>
      </section>
    </React.Fragment>
  )
}

PurposeHeroAndDesc.propTypes = {
  isPhone: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
}

export default PurposeHeroAndDesc
